import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const FinancialsTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);

useEffect(() => {
if (showMasterShipper==true || showCustomBroker == true || showSecondNotify == true || showThirdNotify == true ||
showTransporter == true ||
showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showMasterShipper, showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo,
showBookingParty, showSeller,
showImporter, showBuyer])

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">

            <div className="py-2">
                <div className="row d-flex align-items-center gap-1 flex-row ">

                    {/* <i className="fa fa-map-marker-alt text-danger me-1"></i> */}
                    <span className="text-danger fw-bold">Flow To Be Added</span>
                    <span className="text-muted">: Flow Will be Added in Future.</span>

                </div>
            </div>

        </div>

        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default FinancialsTab